/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * HTTP method filter
 */
export const HttpMethod = {
  Get: "GET",
  Post: "POST",
  Put: "PUT",
  Patch: "PATCH",
  Delete: "DELETE",
  Head: "HEAD",
  Options: "OPTIONS",
} as const;
/**
 * HTTP method filter
 */
export type HttpMethod = ClosedEnum<typeof HttpMethod>;

/**
 * Severity level filter
 */
export const SeverityText = {
  Debug: "DEBUG",
  Info: "INFO",
  Warn: "WARN",
  Error: "ERROR",
  Fatal: "FATAL",
} as const;
/**
 * Severity level filter
 */
export type SeverityText = ClosedEnum<typeof SeverityText>;

/**
 * Filter criteria for searching logs
 */
export type SearchLogsFilter = {
  /**
   * Deployment ID filter
   */
  deploymentId?: string | undefined;
  /**
   * Event source filter (e.g., 'hook', 'tool_call', 'chat_completion')
   */
  eventSource?: string | undefined;
  /**
   * External user ID filter
   */
  externalUserId?: string | undefined;
  /**
   * Start time in ISO 8601 format (e.g., '2025-12-19T10:00:00Z')
   */
  from?: Date | undefined;
  /**
   * Function ID filter
   */
  functionId?: string | undefined;
  /**
   * Chat ID filter
   */
  gramChatId?: string | undefined;
  /**
   * Speakeasy URN filter (single URN, use gram_urns for multiple)
   */
  gramUrn?: string | undefined;
  /**
   * Speakeasy URN filter (one or more URNs)
   */
  gramUrns?: Array<string> | undefined;
  /**
   * HTTP method filter
   */
  httpMethod?: HttpMethod | undefined;
  /**
   * HTTP route filter
   */
  httpRoute?: string | undefined;
  /**
   * HTTP status code filter
   */
  httpStatusCode?: number | undefined;
  /**
   * Service name filter
   */
  serviceName?: string | undefined;
  /**
   * Severity level filter
   */
  severityText?: SeverityText | undefined;
  /**
   * End time in ISO 8601 format (e.g., '2025-12-19T11:00:00Z')
   */
  to?: Date | undefined;
  /**
   * Trace ID filter (32 hex characters)
   */
  traceId?: string | undefined;
  /**
   * User ID filter
   */
  userId?: string | undefined;
};

/** @internal */
export const HttpMethod$outboundSchema: z.ZodMiniEnum<typeof HttpMethod> = z
  .enum(HttpMethod);

/** @internal */
export const SeverityText$outboundSchema: z.ZodMiniEnum<typeof SeverityText> = z
  .enum(SeverityText);

/** @internal */
export type SearchLogsFilter$Outbound = {
  deployment_id?: string | undefined;
  event_source?: string | undefined;
  external_user_id?: string | undefined;
  from?: string | undefined;
  function_id?: string | undefined;
  gram_chat_id?: string | undefined;
  gram_urn?: string | undefined;
  gram_urns?: Array<string> | undefined;
  http_method?: string | undefined;
  http_route?: string | undefined;
  http_status_code?: number | undefined;
  service_name?: string | undefined;
  severity_text?: string | undefined;
  to?: string | undefined;
  trace_id?: string | undefined;
  user_id?: string | undefined;
};

/** @internal */
export const SearchLogsFilter$outboundSchema: z.ZodMiniType<
  SearchLogsFilter$Outbound,
  SearchLogsFilter
> = z.pipe(
  z.object({
    deploymentId: z.optional(z.string()),
    eventSource: z.optional(z.string()),
    externalUserId: z.optional(z.string()),
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    functionId: z.optional(z.string()),
    gramChatId: z.optional(z.string()),
    gramUrn: z.optional(z.string()),
    gramUrns: z.optional(z.array(z.string())),
    httpMethod: z.optional(HttpMethod$outboundSchema),
    httpRoute: z.optional(z.string()),
    httpStatusCode: z.optional(z.int()),
    serviceName: z.optional(z.string()),
    severityText: z.optional(SeverityText$outboundSchema),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    traceId: z.optional(z.string()),
    userId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      deploymentId: "deployment_id",
      eventSource: "event_source",
      externalUserId: "external_user_id",
      functionId: "function_id",
      gramChatId: "gram_chat_id",
      gramUrn: "gram_urn",
      gramUrns: "gram_urns",
      httpMethod: "http_method",
      httpRoute: "http_route",
      httpStatusCode: "http_status_code",
      serviceName: "service_name",
      severityText: "severity_text",
      traceId: "trace_id",
      userId: "user_id",
    });
  }),
);

export function searchLogsFilterToJSON(
  searchLogsFilter: SearchLogsFilter,
): string {
  return JSON.stringify(
    SearchLogsFilter$outboundSchema.parse(searchLogsFilter),
  );
}
